import { useRef } from 'react'
import { useFetchEmail, UseFetchEmailInterface } from '../../../hooks/use-fetch-email'
import { managementSelectors, useManagement } from '../../../store'
import Body from '../../entities/Body'
import ContentOverlay from '../ContentOverlay'

const Content = (emailProps: UseFetchEmailInterface) => {
  const contentRef = useRef<HTMLDivElement>(null!)
  const isMobile = useManagement(managementSelectors.isMobile)

  useFetchEmail(emailProps)

  return (
    <div className="font-times relative w-full text-black" ref={contentRef}>
      {isMobile ? (
        <div className="z-1 absolute left-1/2 top-5 h-[660px] w-[375px] -translate-x-1/2 transform overflow-hidden rounded-[20px] border-[10px] border-b-[50px] border-t-[30px] border-[#23282d]">
          <div className="customScroll h-full overflow-auto scroll-smooth">
            <Body key={'mobile'} />
            <ContentOverlay />
          </div>
        </div>
      ) : (
        <div className="h-[calc(100vh-69px)] overflow-hidden">
          <div className="customScroll h-full overflow-auto scroll-smooth">
            <Body key={'desktop'} />
          </div>
        </div>
      )}
      <ContentOverlay />
    </div>
  )
}

export default Content
